import React,{useEffect, useState} from 'react';
import {Grid,Box,Dialog,Theme} from '@mui/material'
import { createStyles, makeStyles } from "@mui/styles";
import DrDetails from './drDetails';
import { useStore } from '../../store/StoreProvider';
import AppointmentForm from './aptForm';
import DialogHeader from './dialogHeder';
import SuccessAPT from './successAPT';
import { motion } from 'framer-motion';
import { RouterView } from 'hooks/RouteProvider'; // Import hooks
import { customRoutes } from 'utils/constants';
import APTDetails from './aptDetails';
interface props{
data?:any
}

const useStyles = makeStyles((theme:Theme) =>
    createStyles({
      DRDetailsMain:{
        [theme.breakpoints.up('lg')]:{
          height:"90%"
        },
        [theme.breakpoints.down('sm')]:{
          height:"100%"
        }
      },
        dialogMain:{
            '& .MuiDialog-paper': {
               [theme.breakpoints.up('lg')]:{
                minWidth: '55%',
               },
               [theme.breakpoints.up('md')]:{
                paddingLeft:"32px",
                paddingRight:"32px",
               },
                [theme.breakpoints.down('lg')]:{
                marginLeft:"10px",
                marginRight:"10px",
                paddingLeft:"15px",
                paddingRight:"15px",
               },
               
               [theme.breakpoints.down('md')]:{
                minWidth: '87%',
               },
               height:"85%",
              },
        }
        
    })
  );

const BookAppoiointment:React.FC<props>= ({data})=> {
    const store = useStore();
    const classes = useStyles();
    const [open, setOpen] = useState(true);
    useEffect(()=>{
      store.setData(data)
    },[])
    const handleClose = () => {
      setOpen(false);
    };
  return (
    <Box sx={{display:"flex",justifyContent:"center"}}>
        <Dialog open={open} onClose={handleClose} className={classes.dialogMain}>
        <Grid sx={{height:"100%"}}>
        <Grid>
          <DialogHeader handleClose={handleClose} BusinessDetails={data?.BusinessDetails}></DialogHeader>
        </Grid>
            
        <RouterView>
            {({ route }) => (
              <motion.div
                key={route}
                className={route === customRoutes.DRDetails ? classes.DRDetailsMain : ''}
                initial={{ opacity: 0}}
                animate={{ opacity: 1}}
                exit={{ opacity: 0 }}
              >
                {route === customRoutes.APTDetails && (
                  <APTDetails AppointmentTypes={data?.AppointmentTypes} Providers={data?.Providers} Addresses={data?.Addresses} Schedules={data?.Schedules} AppointmentTypeDoctors={data?.AppointmentTypeDoctors} />
                )}
                
                {route === customRoutes.DRDetails && (
                  <DrDetails Providers={data?.Providers} Schedules={data?.Schedules} AppointmentTypeDoctors={data?.AppointmentTypeDoctors} />
                )}
                {route === customRoutes.appointmentForm && (
                  <AppointmentForm />
                )}
                {route === customRoutes.successAPT && (
                  <SuccessAPT />
                )}
              </motion.div>
            )}
         </RouterView>
       
        </Grid>
      </Dialog>
    </Box>
  )
}

export default BookAppoiointment